import { createServerFn } from '@tanstack/react-start'
import { getFromS3, listFromS3 } from '../../lib/s3'
import type { Recipe, RecipeListItem } from './recipeSchemas'

export const getRecipes = createServerFn({ method: 'GET' }).handler(
  async (): Promise<RecipeListItem[]> => {
    try {
      const keys = await listFromS3('recipes/')
      const recipes: RecipeListItem[] = []
      for (const key of keys) {
        if (key && key.endsWith('.json')) {
          const recipe: Recipe = await getFromS3(key)
          recipes.push({ id: recipe.id, name: recipe.name })
        }
      }
      return recipes.sort((a, b) => a.name.localeCompare(b.name))
    } catch (error) {
      return []
    }
  },
)
